"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _colors = require("../helpers/colors");
var _reactVis = require("react-vis");
var _empty = require("./empty");
require("react-vis/dist/style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColorScale = (0, _colors.colorScaleCategorical)();
var BLURRED_LINK_OPACITY = 0.6;
var FOCUSED_LINK_OPACITY = 0.8;
var SankeyChart = /*#__PURE__*/function (_Component) {
  _inherits(SankeyChart, _Component);
  var _super = _createSuper(SankeyChart);
  function SankeyChart() {
    var _this;
    _classCallCheck(this, SankeyChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeLink: null
    });
    _defineProperty(_assertThisInitialized(_this), "_processData", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        colorMap = _this$props.colorMap,
        totalIndex = _this$props.totalIndex;
      var getColor = function getColor(k) {
        return colorMap ? colorMap[k] : defaultColorScale(k);
      };
      var nodes = [];
      var links = [];
      var nodeIndex = {};
      var updateNodeIndex = function updateNodeIndex(nodeKey) {
        if (!nodeIndex[nodeKey]) {
          nodes.push({
            name: nodeKey,
            color: getColor(nodeKey)
          });
          nodeIndex[nodeKey] = nodes.length - 1;
        }
      };
      var getNodesEdges = function getNodesEdges(source, graph) {
        updateNodeIndex(source);
        if (!isNaN(graph)) {
          return graph;
        }
        var value = 0;
        graph.forEach(function (subGraph) {
          var target = subGraph["k"];
          var v = getNodesEdges(target, subGraph["v"]);
          value += v;
          links.push({
            source: nodeIndex[source],
            target: nodeIndex[target],
            value: v,
            color: getColor(target)
          });
        });
        return value;
      };
      getNodesEdges(totalIndex, data);
      return {
        nodes: links.length ? nodes : [],
        links: links
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_renderHint", function () {
      var activeLink = _this.state.activeLink;

      // calculate center x,y position of link for positioning of hint
      var x = activeLink.source.x1 + (activeLink.target.x0 - activeLink.source.x1) / 2;
      var y = activeLink.y0 - (activeLink.y0 - activeLink.y1) / 2;
      var hintValue = _defineProperty({}, "".concat(activeLink.source.name, " \u279E ").concat(activeLink.target.name), activeLink.value);
      return /*#__PURE__*/_react.default.createElement(_reactVis.Hint, {
        x: x,
        y: y,
        value: hintValue
      });
    });
    return _this;
  }
  _createClass(SankeyChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        height = _this$props2.height,
        width = _this$props2.width,
        margin = _this$props2.margin;
      var _this$_processData = this._processData(),
        nodes = _this$_processData.nodes,
        links = _this$_processData.links;
      var activeLink = this.state.activeLink;
      var sankeyStyle = {
        labels: {
          fill: "gray",
          fontSize: "0.8em"
        }
      };
      return /*#__PURE__*/_react.default.createElement(_reactVis.Sankey, {
        nodes: nodes,
        links: links.map(function (d, i) {
          return _objectSpread(_objectSpread({}, d), {}, {
            opacity: activeLink && i === activeLink.index ? FOCUSED_LINK_OPACITY : BLURRED_LINK_OPACITY
          });
        }),
        width: width,
        height: height,
        margin: margin,
        hasVoronoi: false // do not use voronoi in combination with link mouse over
        ,
        layout: 0 // to turn off layout computation and use array order
        ,
        onLinkMouseOver: function onLinkMouseOver(node) {
          return _this2.setState({
            activeLink: node
          });
        },
        onLinkMouseOut: function onLinkMouseOut() {
          return _this2.setState({
            activeLink: null
          });
        },
        style: sankeyStyle,
        align: "left"
      }, activeLink && this._renderHint());
    }
  }]);
  return SankeyChart;
}(_react.Component);
_defineProperty(SankeyChart, "propTypes", {
  data: _propTypes.default.array.isRequired,
  colorMap: _propTypes.default.object,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  totalIndex: _propTypes.default.string,
  totalLabel: _propTypes.default.string
});
_defineProperty(SankeyChart, "defaultProps", {
  width: 800,
  height: 400,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  },
  totalIndex: "Total",
  totalLabel: "Total"
});
var _default = (0, _empty.withEmptyView)(SankeyChart);
exports.default = _default;